import { Component, OnInit } from '@angular/core';
import { Router , ActivatedRoute} from '@angular/router';
import { AuthService } from '../../shared/auth.service';
import { NavMenuItems } from './nav-menu.constant';
import { LoginService } from '@root/components/login/login.service';
@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss'],
})
export class NavMenuComponent implements OnInit {

  public userInfo: any;

  public menuItems = [];

  public defaultPath = 'reports';

  activeNavMain: string;
  constructor(
    private loginService:LoginService,
    private route:ActivatedRoute,
    private router: Router,
    public authService: AuthService) {

  }

  ngOnInit() {
    this.userInfo = AuthService.userInfo();
    const menuItems = [];

    for(const item of NavMenuItems){
      if(!item.disabled && AuthService.isAccess(item.name) && 
       (this.userInfo.isAdmin || this.userInfo.isSuperAdmin || (this.userInfo.isUser && item.roles.indexOf('user')!==-1))){
        menuItems.push(item);
      }
    }
    this.menuItems = menuItems;
    this.routeToDefaultPtah();
  }

  public routeToDefaultPtah() {
    const defaultMenuItem = this.menuItems[0];
    if(defaultMenuItem){
      this.onRoute( defaultMenuItem.path);
    }
  }

  public onRoute(path:string){
    if(path){
      this.activeNavMain = path;
      this.router.navigate([path], {relativeTo: this.route})
    }
  }

  changePassword = () => {
    this.router.navigate(['/home/change-password']);
  };

  logout = () => {
    this.loginService.logout().subscribe(
      data=>{
        this.authService.logout();
    });
  };
}
